import { ReturnProductSchema } from "@redotech/redo-model/draft-return/draft-return-items";
import * as z from "zod/v4";

export const warmExchangeAgentCaches = {
  name: "warmExchangeAgentCaches" as const,
  input: z.object({
    draftReturnId: z.string(),
    currentReturnProductId: z.string(),
    productsBeingReturned: z.array(ReturnProductSchema),
    ignorePersonalizedRecommendations: z.boolean().optional(),
  }),
  output: z.void(),
};
